import { render, staticRenderFns } from "./QuoteDetailsDia.vue?vue&type=template&id=5687d4e0&scoped=true"
import script from "./QuoteDetailsDia.vue?vue&type=script&lang=js"
export * from "./QuoteDetailsDia.vue?vue&type=script&lang=js"
import style0 from "./QuoteDetailsDia.vue?vue&type=style&index=0&id=5687d4e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5687d4e0",
  null
  
)

export default component.exports